<template>
  <div class="collapse-label">
    <div class="collapse-label__label" @click="toggleClick()">{{ title }}</div>
    <div class="collapse-label__toggle" v-if="canOpen" @click="toggleOpen()">
      <ToggleArrow :width="8" :closed="!open"></ToggleArrow>
    </div>
  </div><!-- /.collapse-label -->
</template>

<script>
// import _ from 'lodash'
import ToggleArrow from '../shared/ToggleArrow.vue'

export default {
  name: 'collapse-label',
  components: { ToggleArrow },
  props: {
    title: {
      type: String,
      required: true
    },
    closed: {
      type: Boolean,
      default: false
    },
    canOpen: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      open: false
    }
  },
  mounted () {
    this.open = !this.closed
  },
  watch: {
    closed () {
      this.open = !this.closed
    }
  },
  methods: {
    toggleOpen () {
      this.open = !this.open
      this.$emit('toggleOpen')
    },
    toggleClick () {
      this.$emit('toggleClick')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/components/sass/shared/colors';
@import '~@/components/sass/shared/fonts';

.collapse-label{
  display: flex; -js-display: flex;
  flex-wrap: nowrap;
}

.collapse-label__toggle,
.collapse-label__label{
  flex: 1 1 auto;
}

.collapse-label__toggle{
  max-width: 25px;
  text-align: right;
  width: 25px;
}

.collapse-label__svg{
  display: inline-block;
  height: 5px; // 50
  width: 6px; // 60
}

.collapse-label__label{ padding-right: 10px; }

</style>



// WEBPACK FOOTER //
// src/components/shared/navigation/CountriesNavigation/CollapseLabel.vue